import React from 'react';
import styles from './ContactMap.module.scss';
import { ContactMapNoCoordinates } from './ContactMapNoCoordinates/ContactMapNoCoordinates';
import { StaticMap } from './StaticMap/StaticMap';
import { GeoLocationCoords } from 'ui-smartforce-settings';
import { AddressCard } from './AddressCard/AddressCard';
import {
  CadSummaryType,
  ContactSummaryType,
  ReportSummaryCard
} from './ReportSummaryCard/ReportSummaryCard';

export interface ContactMapProps {
  className?: string;
  coords?: GeoLocationCoords;
  address?: string;
  areas?: string[];
  contactSummary?: ContactSummaryType;
  cadSummary?: CadSummaryType | null;
}

export const ContactMap = ({
  className = '',
  coords,
  address,
  areas,
  contactSummary,
  cadSummary
}: ContactMapProps): React.ReactElement<ContactMapProps> => {
  return (
    <div className={`${styles.contactMap} ${className}`}>
      <div className={styles.mapInfoContainer}>
        <div className={styles.infoWrapper}>
          <AddressCard address={address} areas={areas} />
          <ReportSummaryCard
            contactSummary={contactSummary}
            cadSummary={cadSummary}
          />
        </div>
      </div>

      {!coords && <ContactMapNoCoordinates />}

      {coords && <StaticMap className={styles.leftMap} position={coords} />}
    </div>
  );
};
